module.exports = __webpack_public_path__ + "img/00005.492833ee.webp";